import { render, staticRenderFns } from "./Plyaerstats.vue?vue&type=template&id=839d741e&scoped=true&"
import script from "./Plyaerstats.vue?vue&type=script&lang=js&"
export * from "./Plyaerstats.vue?vue&type=script&lang=js&"
import style0 from "./Plyaerstats.vue?vue&type=style&index=0&id=839d741e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839d741e",
  null
  
)

export default component.exports